import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { canAccessCommandCentre } from '../../auth/commandCentreAccess';
import { useAuth } from '../../auth/AuthProvider';
import { buildCommandCenterPath } from '../../helpers/commandCentreRouting';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const { status, error, login, clearError, user } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    clearError();
  }, [clearError]);

  if (status === 'authenticated') {
    const destination = canAccessCommandCentre(user?.role)
      ? buildCommandCenterPath(undefined, location.search)
      : buildCommandCenterPath(undefined, location.search);
    return <Navigate to={destination} replace />;
  }

  const isSubmitting = status === 'initializing';
  const isForbidden = status === 'forbidden';

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await login(email, password);
  };

  return (
    <div className="login-screen">
      <div className="login-panel">
        <div className="login-branding">
          <p className="login-eyebrow">Elite Core</p>
          <h1>Command Centre</h1>
          <p className="login-copy">
            Sign in with your Elite Core administrator account to access the Command Centre.
          </p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <label>
            <span>Email</span>
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>

          <label>
            <span>Password</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </label>

          {error ? (
            <div className={`login-message ${isForbidden ? 'forbidden' : 'error'}`}>
              {error}
            </div>
          ) : null}

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
